/* eslint-disable camelcase */
import Intercom, { show, shutdown } from '@intercom/messenger-js-sdk';
import type { User } from 'services/FirebaseService/auth';

const MS_PER_SECOND = 1000;

const INTERCOM_VERTICAL_PADDING = 100;

type IntercomAlignment = 'left' | 'right';

interface SyncIntercomParams {
  user: User | null;
  enabled: boolean;
  alignment?: IntercomAlignment;
}

export const syncIntercom = ({
  user,
  enabled,
  alignment = 'right',
}: SyncIntercomParams): boolean => {
  const appId = import.meta.env.VITE_INTERCOM_APP_ID?.trim();

  if (!appId || appId === '') {
    // eslint-disable-next-line no-console
    console.warn(
      'Intercom app ID is not set. Intercom will not be initialized.',
      appId,
    );
    return false;
  }

  if (!enabled || !user) {
    if (window.Intercom) shutdown();
    return false;
  }

  Intercom({
    app_id: appId,
    user_id: user.uid,
    name: user.displayName ?? '',
    email: user.email ?? '',
    created_at: Math.floor(
      new Date(user.metadata.creationTime ?? 0).getTime() / MS_PER_SECOND,
    ),
    vertical_padding: INTERCOM_VERTICAL_PADDING,
    alignment,
    hide_default_launcher: true,
  });

  return true;
};

export const openIntercomMessenger = () => show();
